





























import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class ListItemWithTooltip extends Vue {
  @Prop({ required: true })
  title!: string;

  @Prop()
  icon!: string;

  @Prop()
  value!: string;

  @Prop({ type: Boolean, default: true })
  isEnabled!: boolean;

  @Prop({ type: Boolean })
  hasBadge!: boolean;

  // START - Tooltip props
  @Prop()
  tooltipText!: string;

  @Prop({ type: Boolean })
  isShowTooltip!: boolean;
  // END - Tooltip props

  @Emit()
  onListItemClick() {
    return this.value;
  }
}
